import BulkUploadMembersTable from './BulkUploadMembersTable.component';

export default BulkUploadMembersTable;